const FileTypes = '.jpg, .png, .gif, .jpeg';
  
  export default FileTypes;
  